module.exports = __webpack_public_path__ + "img/university_8.b01136a2.jpg";